import React from 'react'
import reactStamp from 'react-stamp'
import './devices.css'

export default reactStamp(React).compose({

    render() {
        let activeDeviceClass;
        if (sessionStorage.getItem("fitbit") == "true") {
            activeDeviceClass = "device-1 connected"
        } else {
            activeDeviceClass = "device-1"
        }

        return (
            <div className="devices-container">
                <h1 className="devices-title">Devices</h1>
                <p className="description">
                    Connect your fitness or medical device(s) to share the data with your primary care team.
                </p>
                <img className={activeDeviceClass}
                     src="http://designerfund.com/bridge/wp-content/uploads/2015/08/fitbit.png"
                     onClick={this.props.fitbitAuthorize}/>
                <img className="device-1"
                     src="http://www.drivingsales.com/news/wp-content/uploads/2015/03/apple-watch-logo-736x490.jpg"/>
                <img className="device-1"
                     src="http://vignette3.wikia.nocookie.net/quantifiedself/images/5/5d/Jawbone_Logo.jpg/revision/latest?cb=20130523231953"/>
                <img className="device-1"
                     src="http://www.harolsblog.com/wp-content/uploads/2009/07/nike-plus-logo.gif"/>
                <img className="device-1" src="http://www.watsons.com.sg/medias/sys_master/hd5/h88/8799388336158.jpg"/>
            </div>
        )
    }

});



/** WEBPACK FOOTER **
 ** ./src/app/components/Devices/index.js
 **/